<template>
  <el-container class="app-container">
    <el-header height="60px" class="app-header">
      <div class="header-left">
        <img src="@/assets/guohui.png" alt="logo" class="logo" />
        <div class="divider"></div>
        <h1 class="system-name">{{ systemConfig.name }}</h1>
      </div>
      <div class="header-right">
        <span class="user-info">
          <i class="el-icon-user"></i>
          {{ userInfo.userName }}
        </span>
        <div class="divider"></div>
        <el-button type="text" class="header-btn" @click="handleChangePassword">
          <i class="el-icon-key"></i>
          修改密码
        </el-button>
        <el-button type="text" class="header-btn" @click="handleLogout">
          <i class="el-icon-switch-button"></i>
          退出
        </el-button>
      </div>
    </el-header>
    <el-container class="main-container">
      <el-aside width="220px" class="app-aside">
        <el-menu
          :default-active="activeMenu"
          @select="handleMenuSelect"
          router
          class="app-menu"
          :background-color="menuConfig.bgColor"
          :text-color="menuConfig.textColor"
          :active-text-color="menuConfig.activeTextColor"
        >
          <el-menu-item v-for="menu in filteredMenus" :key="menu.menuId" :index="menu.pageRoute">
            <i v-if="menu.menuLogo" :class="menu.menuLogo"></i>
            <span>{{ menu.menuName }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main class="app-main">
        <div class="main-content">
          <router-view/>
        </div>
      </el-main>
    </el-container>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      @close="resetPasswordForm"
      class="password-dialog"
    >
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordFormRef" label-width="100px">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" show-password />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" show-password />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPasswordChange">确定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import Placeholder from './Placeholder.vue'
import { getUserInfo } from '@/api/auth'
import { getUserMenuList } from '@/api/menu'
import { getSystemConfig } from '@/api/system'
import request from '@/utils/request'

export default {
  data() {
    // 验证确认密码
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      menus: [],
      activeMenu: '',
      userInfo: {
        userName: '',
        roleType: null
      },
      // 菜单配置
      menuConfig: {
        bgColor: '#1a2a3a', // 深色背景
        textColor: '#a3b1cc', // 浅色文本
        activeTextColor: '#ffffff' // 选中文本颜色
      },
      // 修改密码相关数据
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      systemConfig: {
        name: '',
        shortName: '',
        logo: '',
        copyright: ''
      }
    }
  },
  computed: {
    filteredMenus() {
      return this.menus
    }
  },
  created() {
    this.getUserInfo()
    this.loadMenus()
    this.loadSystemConfig()
  },
  methods: {
    // 加载系统配置
    async loadSystemConfig() {
      try {
        const res = await getSystemConfig()
        this.systemConfig = res.data
        document.title = this.systemConfig.name || '系统首页'
      } catch (error) {
        console.error('获取系统配置失败:', error)
      }
    },
    // 获取用户信息
    async getUserInfo() {
      try {
        const res = await getUserInfo()
        this.userInfo = res.data
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.$message.error('获取用户信息失败')
      }
    },
    // 加载菜单
    async loadMenus() {
      try {
        const res = await getUserMenuList()
        if (res.code === 200) {
          this.menus = res.data
          
          // 修复默认选中逻辑
          if (this.$route.path === '/' || !this.$route.path) {
            // 如果路径是根路径或为空，则选中第一个菜单并跳转
            if (this.menus.length > 0) {
              this.activeMenu = this.menus[0].pageRoute
              console.log("this.activeMenu",this.activeMenu)
              // 导航到第一个菜单
              this.$nextTick(() => {
                this.$router.push(this.activeMenu).catch(err => {
                  if (err.name !== 'NavigationDuplicated') {
                    throw err
                  }
                })
              })
            }
          } else {
            // 如果有特定路径，则激活匹配的菜单
            this.activeMenu = this.$route.path
            // 去掉首字母的斜杠
            const routepath = this.$route.path.startsWith('/') ? this.$route.path.slice(1) : this.$route.path
            // 检查当前路径是否在菜单中，如果不在则默认选中第一个
            const menuExists = this.menus.some(menu => menu.pageRoute === routepath)
            if (!menuExists && this.menus.length > 0) {
              this.activeMenu = this.menus[0].pageRoute
            } else {
              this.activeMenu = routepath
            }
            console.log("this.activeMenu",this.activeMenu)
            this.$nextTick(() => {
              this.$router.push(this.activeMenu).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                  throw err
                }
              })
            })
          }
        }
      } catch (error) {
        console.error('加载菜单失败:', error)
        this.$message.error('加载菜单失败')
      }
    },
    // 处理菜单选择
    handleMenuSelect(index) {
      if (!index) return
      
      this.activeMenu = index
      // 如果当前路由与选中的菜单不同，则进行跳转
      if (this.$route.path !== index) {
        this.$router.push(index).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        })
      }
    },
    // 处理退出登录
    handleLogout() {
      this.$confirm('确认退出登录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        this.$router.push('/login')
        this.$message.success('已退出登录')
      }).catch(() => {})
    },
    // 获取角色类型名称
    getRoleTypeName(roleType) {
      const roleTypes = {
        1: '超级管理员',
        2: '单位租户管理员',
        3: '普通用户'
      }
      return roleTypes[roleType] || '未知'
    },
    // 处理修改密码
    handleChangePassword() {
      this.passwordDialogVisible = true
    },
    // 重置密码表单
    resetPasswordForm() {
      if (this.$refs.passwordFormRef) {
        this.$refs.passwordFormRef.resetFields()
      }
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    },
    // 提交密码修改
    async submitPasswordChange() {
      try {
        await this.$refs.passwordFormRef.validate()
        
        await request({
          url: '/user/change-password',
          method: 'post',
          data: {
            oldPassword: this.passwordForm.oldPassword,
            newPassword: this.passwordForm.newPassword
          }
        })

        this.$message.success('密码修改成功，请重新登录')
        this.passwordDialogVisible = false
        
        // 退出登录
        localStorage.removeItem('token')
        this.$router.push('/login')
      } catch (error) {
        if (error === false) return // 表单验证失败
        console.error('修改密码失败:', error)
        this.$message.error(error.response.data.message || '修改密码失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-header {
  background: linear-gradient(90deg, #2c3e50 0%, #3498db 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  position: relative;
  z-index: 10;
  flex-shrink: 0;

  .header-left {
    display: flex;
    align-items: center;

    .logo {
      width: 40px;
      height: auto;
      margin-right: 16px;
    }

    .divider {
      width: 1px;
      height: 24px;
      background: rgba(255, 255, 255, 0.3);
      margin: 0 16px;
    }

    .system-name {
      font-size: 22px;
      font-weight: 600;
      color: #ffffff;
      margin: 0;
      letter-spacing: 1px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    .user-info {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
      padding: 0 16px;

      i {
        margin-right: 8px;
        font-size: 16px;
      }
    }

    .divider {
      width: 1px;
      height: 20px;
      background: rgba(255, 255, 255, 0.3);
      margin: 0 8px;
    }

    .header-btn {
      color: #fff;
      font-size: 14px;
      padding: 6px 16px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        border-radius: 4px;
      }

      i {
        margin-right: 6px;
        font-size: 16px;
      }
    }
  }
}

.main-container {
  flex: 1;
  display: flex;
  height: calc(100vh - 60px);
  overflow: hidden;
}

.app-aside {
  background: #1a2a3a;
  z-index: 9;
  width: 220px !important;
  border-right: none;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

  .app-menu {
    border: none;
    padding: 16px 0;
    background: transparent;
    overflow-y: auto;
    flex: 1;

    :deep(.el-menu-item) {
      height: 48px;
      line-height: 48px;
      margin: 4px 12px;
      width: calc(100% - 24px);
      border-radius: 4px;
      font-size: 14px;
      
      &:hover, &:focus {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.1) !important;
      }

      &.is-active {
        color: #ffffff !important;
        background: #3498db !important;
        box-shadow: 0 2px 6px rgba(52, 152, 219, 0.3);
      }

      i {
        margin-right: 12px;
        font-size: 18px;
      }
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 2px;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}

.app-main {
  flex: 1;
  height: 100%;
  padding: 12px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;

  .main-content {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 20px;
    overflow-y: auto;
    margin: 0;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #d9d9d9;
      border-radius: 3px;

      &:hover {
        background: #bfbfbf;
      }
    }

    &::-webkit-scrollbar-track {
      background: #f5f5f5;
      border-radius: 3px;
    }
  }
}

.password-dialog {
  :deep(.el-dialog) {
    border-radius: 8px;
    overflow: hidden;

    .el-dialog__header {
      padding: 20px 24px;
      background: #2c3e50;
      margin: 0;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
      }
    }

    .el-dialog__body {
      padding: 32px 40px;
    }

    .el-dialog__footer {
      padding: 16px 24px;
      border-top: 1px solid #f0f0f0;
      background: #f8f9fa;
    }
  }

  :deep(.el-form-item) {
    margin-bottom: 24px;

    .el-form-item__label {
      font-weight: 500;
      color: #333;
    }

    .el-input__inner {
      border-radius: 4px;
      height: 38px;
      line-height: 38px;

      &:hover, &:focus {
        border-color: #3498db;
      }
    }
  }

  :deep(.el-button) {
    padding: 10px 24px;
    border-radius: 4px;
    font-size: 14px;

    &.el-button--primary {
      background: #3498db;
      border-color: #3498db;

      &:hover {
        background: #2980b9;
        border-color: #2980b9;
      }

      &:active {
        background: #1c6ea4;
        border-color: #1c6ea4;
      }
    }
  }
}
</style>